import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useState } from "react"
import { Alert, Appearance, FlatList, ImageStyle, ScrollView, TextStyle, View, ViewStyle } from "react-native"
import { AutoImage, Button, JalaIcon, Screen, Text } from "../../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps, useFocusEffect } from "@react-navigation/native"
import { Modal } from "native-base"
import { translate, TxKeyPath } from "../../../../i18n"
import { useStores } from "../../../../models"
import { goBack, navigate } from "../../../../navigators"
import { color } from "../../../../theme"
import config from "../../../../utils/config"
import { Access } from "./add-member/add-member-screen"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flexGrow: 1,
  paddingBottom: 20
}

const TEXT_HEADER: TextStyle = {
  paddingVertical: 20,
  paddingHorizontal: 20,
  borderBottomWidth: 0.2,
  color: color.primaryDarker,
  borderColor: color.palette.gray200
}

const FARM_PROFILE_WRAPPER: ViewStyle = {
  paddingHorizontal: 20,
  paddingVertical: 10,
  borderBottomWidth: 0.2,
  borderColor: color.palette.gray200
}

const SEPARATOR: ViewStyle = {
  backgroundColor: color.palette.backgroundGray,
  flexDirection: 'row',
  paddingHorizontal: 20,
  paddingVertical: 20,
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottomWidth: 0.5,
  borderColor: color.palette.gray200
}

const TEXT_ROLE: TextStyle = {
  color: color.primaryDarker
}

const ROLE_CONTAINER: ViewStyle = {
  flexDirection: 'row',
  paddingHorizontal: 20,
  paddingVertical: 10,
  borderBottomWidth: 0.5,
  borderColor: color.palette.gray200,
  justifyContent: 'flex-start',
  alignItems: 'center',
}

const IMAGE: ImageStyle = {
  width: 50,
  height: 50,
  borderRadius: 50 / 2,
}

const INFO_USER: ViewStyle = {
  flex: 1,
  marginLeft: 10
}

const HEADER_MODAL: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}

const PROFILE_WRAPPER: ViewStyle = {
  flexDirection: 'row',
  paddingVertical: 20,
  alignItems: 'center'
}

const PROFILE_INFO: ViewStyle = {
  paddingHorizontal: 20,
  flex: 1,
}

const IMG: ImageStyle = {
  width: 100,
  height: 100,
  borderRadius: 50
}

const BTN_DELETE: ViewStyle = {
  alignSelf: 'flex-end',
}

const MODAL_CONTAINER: ViewStyle = {
  justifyContent: 'flex-end',
  marginBottom: 0,
  marginTop: "auto"
}

const CONTENT_CONTAINER: ViewStyle = {
  backgroundColor: color.palette.white,
  height: '70%',
  padding: 20,
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,

}

const { BASE_URL } = config();

const ListContent = ({ label, value = "-", colorScheme }:{label?: TxKeyPath, value?: string, colorScheme?: "light" | "dark" }) => (
  <View style={FARM_PROFILE_WRAPPER}>
    <Text preset="title3" tx={label} color={color.primary} colorScheme={colorScheme} />
    <Text preset="title2" text={value} color={color.palette.darkGrey} colorScheme={colorScheme} />
  </View>
)

const FarmProfile = ({ value, colorScheme } : { value?: any, colorScheme?: "light" | "dark" } ) => (
  <View>
    <ListContent label="connectedFarm.farmLabel" value={value.farmName} colorScheme={colorScheme} />
    <ListContent label="connectedFarm.address" value={value.region} colorScheme={colorScheme} />
    <ListContent label="connectedFarm.area" value={value.area} colorScheme={colorScheme} />
  </View>
)

const Separator = ({ role, owner, colorScheme, onPress } : { role?: TxKeyPath, owner?: boolean, colorScheme?: "light" | "dark", onPress?: () => void}) => (
  <View style={SEPARATOR}>
    <Text preset="title2" tx={role} style={TEXT_ROLE} colorScheme={colorScheme} />
    {owner && <Button testID="jala:id/add-member-button" preset="link" tx="connectedFarm.addMember" colorScheme={colorScheme} onPress={onPress} />}
  </View>
)


export const MemberScreen: FC<{ colorScheme?: "light" | "dark", route?: any } & CompositeScreenProps<any, any>> = observer(function MemberScreen(props) {
  // const { colorScheme = useColorScheme(), route: { params : { data , farm, region, area }} } = props
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params : { data , farmName, region, area, selectedFarm }} } = props

  const [ isVisible, setVisible ] = useState<boolean>(false);
  const [ selectedProfile, setSelectedProfile ] = useState<any>(null);

  // Pull in one of our MST stores
  // const { userStore: { user }, farmStore, farmStore: { selectedFarm } } = useStores();
  const { userStore, userStore: { user }, farmStore, farmStore: { needRefresh } } = useStores();

  // const farm = getSnapshot(selectedFarm);

  useFocusEffect(useCallback(() => {
    if (needRefresh) {
      userStore.getFarmProfile();
      farmStore.set('needRefresh', false);
      if (!isVisible) {
        Alert.alert(
          '',
          translate("dataAdded"),
          [{ text: 'OK', onPress: null }]
        )
      }
    }
  }, [farmStore, isVisible, needRefresh, userStore]))

  const onAddPress = () => {
    JalaAnalytic.log('Mobile app: add team');
    navigate("Profile.Stack", 'Profile.Connected.Farm.Member.Add', { data })
  }

  const onEditPress = () => {
    setVisible(!isVisible)
    navigate("Profile.Stack", 'Profile.Connected.Farm.Member.Add', { data: { ...selectedProfile, route: "edit"} })
  }

  const onDelete = () => {
    farmStore.deleteFarmProfile(selectedProfile).then(() => {
      JalaAnalytic.log('Mobile app: delete team');
      setVisible(false);
      setTimeout(() => {
        Alert.alert(
          '',
          translate("deletedData"),
          [{ text: 'OK', onPress: () => goBack('Profile.Stack') }]
        )
      }, 1000)
    })
  }

  const handlePress = (item) => {
    JalaAnalytic.log('Mobile app: view team role');
    setSelectedProfile(item);
    setVisible(!isVisible);
  }

  const mainUser = () => {
    const id = user.id
    const owner = selectedFarm.member.find(m => m.user_id === id)
    const isOwner = owner.role_id === 3;
    return owner && isOwner;
  }

  const ListRole = ({ id, colorScheme, onPress } : { id?: number, colorScheme?: "light" | "dark", onPress?: (data) => void }) => {
    // const filtered = connectedFarm.filter((item) => (item.role_id === id && item.farm_id === data.farm.id ))
    const filtered = selectedFarm.member.filter(member => member.role_id === id);
    return (
        <FlatList data={filtered} renderItem={({ item }) => {
          const { user: { name, email, avatar} } = item;
          const image = `${BASE_URL}/img/cache/medium/${avatar}`
          return (
            <Button testID="jala:id/item-button" preset="link" colorScheme={colorScheme} style={ROLE_CONTAINER} onPress={() => onPress(item)}>
              <AutoImage source={{uri: image}} style={IMAGE} />
              <View style={INFO_USER}>
                <Text preset="body1" color={color.palette.darkestGrey} text={name} colorScheme={colorScheme} />
                <Text preset="body2" color={color.palette.grey} text={email} colorScheme={colorScheme} />
              </View>
              <JalaIcon name="chevron_right" size={24} color={color.primary} />
            </Button>
          )
        }} />
      )
  }

  const Content = () => {
    const { user : { avatar, name, email }, role } = selectedProfile;
    const image = `${BASE_URL}/img/cache/medium/${avatar}`;
    return(
      <View style={CONTENT_CONTAINER}>
        <ScrollView showsVerticalScrollIndicator={false}>
          <View style={HEADER_MODAL}>
            <Text tx="connectedFarm.member" colorScheme={colorScheme} />
            {mainUser() && role.id !== 3 && <Button testID="jala:id/change-access-button" tx="connectedFarm.changeAccess" preset="link" colorScheme={colorScheme} onPress={onEditPress} />}
          </View>
          {selectedProfile && (
            <View style={{marginBottom: 20}}>
              <View style={PROFILE_WRAPPER}>
                <AutoImage source={{ uri: image}} style={IMG} />
                <View style={PROFILE_INFO}>
                  <Text preset="display2" text={name} colorScheme={colorScheme} />
                  <Text preset="body1" text={email} colorScheme={colorScheme} />
                  <Text preset="body1" text={role.display_name} colorScheme={colorScheme} />
                </View>
              </View>
              <Access role={role.display_name} colorScheme={colorScheme} />
              {role.id !== 3 && <Button testID="jala:id/delete-button" tx="delete" textPreset="body1" preset="link" style={BTN_DELETE} colorScheme={colorScheme} onPress={onDelete} />}
            </View>
          )}
        </ScrollView>
      </View>
    )
  }
  
  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={color.primary}
      statusBar="light-content"
     >
      <Text preset="header" tx="connectedFarm.farmProfile" style={TEXT_HEADER} colorScheme={colorScheme} />
        <FarmProfile value={{farmName, region, area}} colorScheme={colorScheme}  />
        <Separator colorScheme={colorScheme} role="connectedFarm.owner" owner={mainUser()} onPress={onAddPress} />
        <ListRole id={3} onPress={handlePress} colorScheme={colorScheme} />
        <Separator colorScheme={colorScheme} role="connectedFarm.admin" />
        <ListRole id={10} onPress={handlePress} colorScheme={colorScheme} />
        <Separator colorScheme={colorScheme} role="connectedFarm.operator" />
        <ListRole id={4} onPress={handlePress} colorScheme={colorScheme} />
        <Separator colorScheme={colorScheme} role="connectedFarm.laboran" />
        <ListRole id={11} onPress={handlePress}  colorScheme={colorScheme} />
        <Separator colorScheme={colorScheme} role="connectedFarm.viewer" />
        <ListRole id={5} onPress={handlePress} colorScheme={colorScheme} />
      <Modal isOpen={isVisible} onClose={() => setVisible(!isVisible)} closeOnOverlayClick animationPreset="slide" style={MODAL_CONTAINER}>
        <Content />
      </Modal>
    </Screen>
  )
})
